import WebsiteDevelopmentOffers from "./WebsiteDevelopmentOffers";

const WebsiteDevelopment = () => {
  return (
    <section className="solution-item-page">
      <WebsiteDevelopmentOffers />
    </section> 
  );
};

export default WebsiteDevelopment;
